import { TextField, Tooltip } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import Heading from "../../../Components/Heading/Heading";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  ExporttoExcelTestCaseIssuereport,
  getTestCaseIssueReport,
  GetDropDownList,
} from "../../../Helpers/API/APIEndPoints";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import axios from "axios";
import fileDownload from "js-file-download";

const TestCaseIssueReport = () => {
  let formErrorObj = {};
  const [formErrors, setFormErrors] = useState({});
  const [gridData, setGridData] = useState<any>([]);

  const [engagementSelectedData, setEngagementSelectedData] = useState([]);

  const [customerSelectData, setCustomerSelectData] = useState([]);
  const [engagementOptions, setEngagementOptions] = useState([]);

  const [fromDate, setFromDate] = useState<Date | null>(
    //moment().startOf("month").toDate()
    null
  );
  const [toDate, setToDate] = useState<Date | null>(
    //moment().endOf("month").toDate()
    null
  );
  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setsortOrder] = useState("");
  const [searchText, setSearchText] = useState("");
  const [pageSize, setpageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(0);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [reset, setReset] = useState(false);
  const [page, setPage] = useState(0);
  const { RoleId, EmployeeId } = getContext();
  const RoleIdArray = RoleId.split(",");
  const [employeeRoldId, setEmployeeRoleId] = useState(0);

  useEffect(() => {
    onLoadApi();
  }, []);

  const onLoadApi = async () => {
    if(RoleIdArray.includes("3")){
      setEmployeeRoleId(3);
    }else if(RoleIdArray.includes("8")){
      setEmployeeRoleId(8);
    }else if(RoleIdArray.includes("2")){
      setEmployeeRoleId(2);
    }else if(RoleIdArray.includes("1")){
      setEmployeeRoleId(1);
    }

    await GetEngagementData();
  };

  useEffect(() => {
    // GetEngagementData()
    (async () => {
      let engagements = await ConvertArrayToString(engagementSelectedData);

     
      let obj = {
        Engagement: engagements,
        FromDate:
          fromDate === null
            ? null
            : moment(fromDate).format(moment.HTML5_FMT.DATE),
        ToDate:
          toDate === null ? null : moment(toDate).format(moment.HTML5_FMT.DATE),
        sortColumn: sortColumn,
        sortOrder: sortOrder,
        searchText: searchText,
        pageSize: pageSize,
        start: start,
        count,
        RoleId : employeeRoldId,
        EmployeeId : EmployeeId,
      };
      await GetGridData(obj);
    })();
  }, [start, sortColumn, sortOrder, searchText, reset, pageSize, page, employeeRoldId, EmployeeId]);

  const GetGridData = async (obj) => {
    showLoader();
    const { data } = await APICall(getTestCaseIssueReport, "POST", obj);

    let arr = [];
    if (data.length > 0) {
      arr = [...data];
      setGridData(data);
    }
    if (arr.length > 0) {
      setCount(arr[0].totalCount);
    } else {
      setStart(0);
      setCount(0);
      setPage(0);
      setGridData([]);
    }
    hideLoader();
  };

  const SelectOnChange = (event, apiField) => {
    if (apiField == "engagement") {
      setEngagementSelectedData(event);


      if (event && Object.keys(event).length > 0) {
        
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: undefined,
        }));
        setPage(0);
        setStart(0);
        
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: "engagement can not be empty",
        }));
      }
    }

    if (apiField == "fromDate") {
      setFromDate(event);
    }
    if (apiField == "toDate") {
      setToDate(event);
    }
  };

  const GetEngagementData = async () => {
    let postObject = {};

    if (RoleId.includes("3")) {
      postObject = {
        searchFor: "TestCaseIssueEngagement",
        searchValue: EmployeeId,
      };
    }
     //added by mahesh for operational manager
     else if (RoleIdArray.includes("8")) {
      postObject = {
        searchFor: "TestCaseIssueEngagement",
        searchValue: EmployeeId,
      };
    }
    //end
     else if (RoleIdArray.includes("2")) {
      postObject = {
        searchFor: "EmanagerTestCaseIssueEngagement",
        searchValue: EmployeeId,
      };
    }
    //added by Deepak Gupta
    else if (RoleIdArray.includes("1")) {
      postObject = {
        searchFor: "EmanagerTestCaseIssueEngagement",
        searchValue: EmployeeId,
      };
    }
    //for manager role to get allengagement
    // else {
    //   postObject = {
    //     searchFor: "TestCaseIssueEngagement",
    //     searchValue: EmployeeId,
    //   };
    // }

    const { data } = await APICall(GetDropDownList, "POST", postObject);

    if (data != undefined || data != null) {
      let engagementArrya = [];
      let s = "";
      s.toLowerCase();
      await data.map((x: any) => {
        let tempObj = {
          value: x.id,
          label: x.name,
        };
        engagementArrya.push(tempObj);
      });
      engagementArrya.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );
      setEngagementOptions(engagementArrya);
    }
  };

  const ConvertArrayToString = (arr) => {
    let s = [];
    arr.map((i) => s.push(i.value));
    return s.join(",");
  };

  const gridColumns = [
    {
      name: "engagement",
      label: "Engagement",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "engagementType",
      label: "EngagementType",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "requirementTitle",
      label: "Requirement",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "preRequisties",
      label: "Pre Requisites",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "description",
      label: "Description",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "expectedResult",
      label: "Expected Result",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "statusTitle",
      label: "Status",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "assignedTo",
      label: "Assigned To",
      options: {
        filter: false,
        sort: false,
      },
    },
    // {
    //   name:"plannedStartDate",
    //   label:"Planned Start Date",
    //   options: {

    //       filter: false,
    //       sort: true,

    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       if (value == null) {
    //         return <p></p>;
    //       } else {
    //         return <p>{moment(value).format(moment.HTML5_FMT.DATE)}</p>;
    //       }
    //     },
    //   },
    // },
    // {
    //   name:"plannedEndDate",
    //   label:"Planned End Date",
    //   options: {

    //       filter: false,
    //       sort: true,

    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       if (value == null) {
    //         return <p></p>;
    //       } else {
    //         return <p>{moment(value).format(moment.HTML5_FMT.DATE)}</p>;
    //       }
    //     },
    //   },
    // },
    // {
    //   name:"actualStartDate",
    //   label:"Actual Start Date",
    //   options: {

    //       filter: false,
    //       sort: false,

    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       if (value == null) {
    //         return <p></p>;
    //       } else {
    //         return <p>{moment(value).format(moment.HTML5_FMT.DATE)}</p>;
    //       }
    //     },
    //   },
    // },
    // {
    //   name:"actualEndDate",
    //   label:"Actual End Date",
    //   options: {

    //       filter: false,
    //       sort: false,

    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       if (value == null) {
    //         return <p></p>;
    //       } else {
    //         return <p>{moment(value).format(moment.HTML5_FMT.DATE)}</p>;
    //       }
    //     },
    //   },
    // },
    {
      name: "hoursAssigned",
      label: "Hours Assigned",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "hoursSpent",
      label: "Hours Spend",
      options: {
        filter: false,
        sort: false,
      },
    },
    // {
    //   name:"natureOfIssue",
    //   label:"Nature Of Issue",
    //   options:{
    //     filter: false,
    //     sort: false,
    //   }
    // },
    {
      name: "remarks",
      label: "Remark",
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      const context = this;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  }

  const onInput = debounce((searchText) => {
    if (searchText !== null) {
      setSearchText(searchText);
    } else {
      setSearchText("");
    }
  }, 1000);

  const object = {
    selectableRows: "none",
    page: page,
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {},
    onSearchChange: (searchText) => {
      // if (searchText !== null) {
      //   setSearchText(searchText);
      // } else {
      //   setSearchText("");
      // }
      onInput(searchText);
    },
    onColumnSortChange: async (sortColumn, sortOrder) => {
      if (sortOrder === "asc") {
        await setSortColumn(sortColumn);
        await setsortOrder(sortOrder);
      }
      if (sortOrder === "desc") {
        await setSortColumn(sortColumn);
        await setsortOrder(sortOrder);
      }
    },
    onChangePage: async (page) => {
      setPage(page);
      setStart(page * pageSize);
    },
  };

  const submitFunc = async (api) => {
    let engagement = await ConvertArrayToString(engagementSelectedData);

    let obj = {
      Engagement: engagement,
      FromDate:
        fromDate === null
          ? null
          : moment(fromDate).format(moment.HTML5_FMT.DATE),
      ToDate:
        toDate === null ? null : moment(toDate).format(moment.HTML5_FMT.DATE),
      sortColumn,
      sortOrder,
      searchText,
      pageSize,
      start,
      count,
      RoleId : employeeRoldId,
      EmployeeId : EmployeeId,
    };

    if (api === "submit") {
      let check = Validation();
      if (check) {
        await GetGridData(obj);
      } else {
        setFromDate(null);
        setToDate(null);
        setEngagementSelectedData([]);
      }
    }

    if (api === "reset") {
      setFromDate(null);
      setToDate(null);
      setEngagementSelectedData([]);
      setReset(!reset);
    }
  };

  const ExportToExcel = () => {
    let engagements = ConvertArrayToString(engagementSelectedData);
    let obj = {
      Engagement: engagements,
      FromDate:
        fromDate === null
          ? null
          : moment(fromDate).format(moment.HTML5_FMT.DATE),
      ToDate:
        toDate === null ? null : moment(toDate).format(moment.HTML5_FMT.DATE),
      RoleId:employeeRoldId,
      EmployeeId:EmployeeId,
      sortColumn: sortColumn,
      sortOrder: sortOrder,
      searchText: searchText,
      pageSize: count,
      start,
      count: count,
    };

    axios
      .request({
        responseType: "blob",
        method: "POST",

        url: ExporttoExcelTestCaseIssuereport,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: obj,
      })
      .then((response) => {
        fileDownload(response.data, "TestCaseIssueReport.xlsx");
      })
      .catch((error) => {});
  };

  const Validation = () => {
    let objError = {};

    if (
      engagementSelectedData == undefined ||
      engagementSelectedData == null ||
      engagementSelectedData.length == 0
    ) {
      objError["engagement_isEmpty"] = "engagement can not be empty";
    }

    formErrorObj = objError;
    setFormErrors(objError);
    const isEmpty = Object.keys(objError).length === 0;

    return isEmpty;
  };

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <Heading title={"TestCase Issue"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-end gap-2">
              <button
                onClick={() => ExportToExcel()}
                className="btn btn-export"
              >
                Export to Excel
              </button>
              <a className="filterIcon" onClick={toggleFilter}>
                <i className="fa fa-filter"></i>
              </a>
            </div>
          </div>

          <div className="col-lg-12">
            {toggle && (
              <div className="row mt-3" id="filterContent">
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      Select Engagement <sup>*</sup>
                    </label>

                    <SelectForm
                      value={engagementSelectedData}
                      onChange={(e) => SelectOnChange(e, "engagement")}
                      options={engagementOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                    <p style={{ color: "red" }}>
                      {formErrors["engagement_isEmpty"]}
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="d-block">From Date</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="To Date"
                        value={fromDate}
                        onChange={(event) => SelectOnChange(event, "fromDate")}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>To Date</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="To Date"
                        value={toDate}
                        onChange={(event) => SelectOnChange(event, "toDate")}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="d-flex justify-content-end gap-2">
                    {/* <Tooltip title="Export to excel">
                      <button
                        onClick={() => ExportToExcel()}
                        className="btn btn-export"
                      >
                        <i className="fa-solid fa-file-arrow-down"></i>
                      </button>
                    </Tooltip> */}
                    <button
                      onClick={() => submitFunc("reset")}
                      className="btn btn-reset"
                    >
                      Reset
                    </button>
                    <button
                      onClick={() => submitFunc("submit")}
                      className="btn btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-lg-12 mt-3">
            {gridData && gridData.length >= 0 && (
              <DynamicGrid
                options={object}
                data={gridData}
                columns={gridColumns}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TestCaseIssueReport;
